<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.project.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.form.type') }}</label>
            <multiselect v-model="filter.projectType" track-by="item1" label="item2"
              :options="projectTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.form.status') }}</label>
            <multiselect v-model="filter.companyStatus" track-by="item1" label="item2"
              :options="companyStatuses" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.status')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>
          
          <div class="form-group col-md-4">
            <label>{{ $t('project.form.reasonInactif') }}</label>
            <multiselect v-model="filter.reasonInactif" track-by="item1" label="item2"
              :options="reasonsInactif" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.form.reasonInactif')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.companyStage') }}</label>
            <multiselect v-model="filter.companyStage" track-by="item1" label="item2"
              :options="companyStages" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.companyStage')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('address.form.region') }}</label>
            <multiselect v-model="filter.region" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('address.form.region')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.sectorOfActivity') }}</label>
            <multiselect v-model="filter.sector" track-by="item1" label="item2"
              :options="sectors" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.sectorOfActivity')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.finances.origin') }}</label>
            <multiselect v-model="filter.origin" track-by="item1" label="item2"
              :options="origins" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.finances.origin')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.company.form.cellule') }}</label>
            <multiselect v-model="filter.cellulle" track-by="id" label="name"
              :options="cellulles" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.company.form.cellule')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-4">
            <label>{{ $t('project.investment.form.type') }}</label>
            <multiselect v-model="filter.investmentType" track-by="item1" label="item2"
              :options="investmentTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.investment.form.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label>{{ $t('project.investment.form.category') }}</label>
            <multiselect v-model="filter.investmentCategory" track-by="item1" label="item2"
              :options="investmentCategorys" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('project.investment.form.category')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-2"> 
            <label for="memberSince">{{ $t('dashboard.project.form.constitutionDateFrom') }}</label>
            <moment-date-picker v-model="filter.constitutionDateFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2">
            <label for="memberSince">{{ $t('dashboard.project.form.constitutionDateTo') }}</label>
            <moment-date-picker v-model="filter.constitutionDateTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2"> 
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementFrom') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementFrom" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2">
            <label for="memberSince">{{ $t('dashboard.project.form.dateOfInvestissementTo') }}</label>
            <moment-date-picker v-model="filter.dateOfInvestissementTo" :required="false"></moment-date-picker>
          </div>

          </div>

        <div class="row">

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueFrom') }}</label>
              <input v-model="filter.totalValueFrom" name="totalValueFrom" type="number" 
                  class="form-control" id="totalValueFrom" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.totalValueTo') }}</label>
              <input v-model="filter.totalValueTo" name="totalValueTo" type="number" 
                  class="form-control" id="totalValueTo" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.quantityInvestmentsFrom') }}</label>
              <input v-model="filter.quantityInvestmentsFrom" name="quantityInvestmentsFrom" type="number" 
                  class="form-control" id="quantityInvestmentsFrom" />
          </div>

          <div class="form-group col-md-2">
              <label for="totalValueInput">{{ $t('dashboard.project.form.quantityInvestmentsTo') }}</label>
              <input v-model="filter.quantityInvestmentsTo" name="quantityInvestmentsTo" type="number" 
                  class="form-control" id="quantityInvestmentsTo" />
          </div>
          
        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >

          <div class="card text-white o-hidden bg-primary mb-3">

            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-building"></i>
              </div>
              <div class="mr-5">{{ $t("dashboard.project.data.title") }}</div>
            </div>
            
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ total }}</span> {{ $t("dashboard.project.data.total") }}</li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalWithInvestment }}</span> {{ $t("dashboard.project.data.totalWithInvestment") }}</li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ meanPreMoney | moneyFormat }}</span> {{ $t("dashboard.project.data.preMoneyMean") }}</li>
            </ul>
          </div>

          <div class="card text-white o-hidden bg-primary mb-3">

            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-building"></i>
              </div>
              <div class="mr-5">{{ $t("dashboard.project.emploi.title") }}</div>
            </div>
            
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalEmployeFullTime }}</span> {{ $t("dashboard.project.emploi.totalTempPlein") }} </li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalEmployePartTime }}</span> {{ $t("dashboard.project.emploi.totalTempPart") }}  </li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalEmployeOther }}</span> {{ $t("dashboard.project.emploi.totalTempOther") }} </li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalEmploye }}</span> {{ $t("dashboard.project.emploi.total") }} </li>
            </ul>
          </div>

          <div class="card text-white o-hidden bg-success mb-3">

            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-money"></i>
              </div>
              <div class="mr-5">{{ $t("dashboard.project.investment.title") }} </div>
            </div>
            
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalInvested | moneyFormat }}</span> {{ $t("dashboard.project.investment.total") }}  </li>
              <li class="list-group-item"><span class="pull-right font-weight-bold">{{ totalInvestments }}</span> {{ $t("dashboard.project.investment.quantity") }} </li>
            </ul>
          </div>

        </div>

        <div class="col-md-9" >

          <div class="row">
            
            <div class="col-md-6"  >

              <div class="card mb-3" v-if="projectTypeData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.project.projectType") }} </div>
                  <pie-chart :chart-data="projectTypeData.data" :options="projectTypeData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-6"  >

              <div class="card mb-3" v-if="regionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.project.region") }} </div>
                  <pie-chart :chart-data="regionData.data" :options="regionData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-6"  >

              <div class="card mb-3" v-if="sectorOfActivityData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.project.sectorOfActivity") }} </div>
                  <pie-chart :chart-data="sectorOfActivityData.data" :options="sectorOfActivityData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-6"  >

              <div class="card mb-3" v-if="statusData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.project.status") }} </div>
                  <pie-chart :chart-data="statusData.data" :options="statusData.options"></pie-chart>
              </div>

            </div>

          </div>

          <div class="row">

              <div class="col-md-12"  >

              <div class="card mb-3" v-if="salaryEvolutionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.project.salaryEvolution") }} </div>
                  <bar-chart :chart-data="salaryEvolutionData.data" :options="salaryEvolutionData.options"></bar-chart>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  ProjectServiceClient,
  InvestmentServiceClient,
  AddressServiceClient,
  RoleServiceClient,
  CompanyServiceClient,
  CompetencyServiceClient,
} from '../../shared/service-clients/service-clients'

import DashboardMixin from '../../shared/Mixin/DashboardMixin'

import palette from 'google-palette'

export default {
  name: 'ProjectDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      data: [],
      regions: [],
      companyStages: [],
      sectors: [],
      origins: [],
      companyStatuses: [],
      processStatuses: [],
      reasonsInactif: [],
      cellulles: [],
      projectTypes: [],
      investmentTypes: [],
      investmentCategorys: [],
      filter: {
        projectType: [],
        companyStatus: [],
        reasonInactif: [],
        companyStage: [],
        region: [],
        sector: [],
        origin: [],
        cellulle: [],
        investmentType: [],
        investmentCategory: [],
        quantityInvestmentsTo: null,
        quantityInvestmentsFrom: null,
        totalValueTo: null,
        totalValueFrom: null,
        constitutionDateTo: null,
        constitutionDateFrom: null,
        dateOfInvestissementTo: null,
        dateOfInvestissementFrom: null,
      },
    }
  },
  computed: {
    filteredData: function() {
      let filtered = this.data

      filtered = this.filterPropertyByList(filtered, this.filter.projectType, 'projectType')
      filtered = this.filterPropertyByList(filtered, this.filter.region, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.companyStatus, 'companyStatus')
      filtered = this.filterPropertyByList(filtered, this.filter.reasonInactif, 'reasonInactif')
      filtered = this.filterPropertyByList(filtered, this.filter.companyStage, 'companyStage')
      filtered = this.filterPropertyByList(filtered, this.filter.sector, 'sector')
      filtered = this.filterPropertyByList(filtered, this.filter.origin, 'origin')
      filtered = this.filterPropertyByList(filtered, this.filter.cellulle, 'cellulle')

      filtered = this.filterPropertyByDateTo(filtered, this.filter.constitutionDateTo, 'constitutionDate')
      filtered = this.filterPropertyByDateFrom(filtered, this.filter.constitutionDateFrom, 'constitutionDate')

      filtered = this.filterSubPropertyByDateTo(filtered, this.filter.dateOfInvestissementTo, 'investments', 'dateOfInvestissement')
      filtered = this.filterSubPropertyByDateFrom(filtered, this.filter.dateOfInvestissementFrom, 'investments', 'dateOfInvestissement')

      filtered = this.filterPropertyByGreaterInteger(filtered, this.filter.quantityInvestmentsTo, 'quantityInvestment')
      filtered = this.filterPropertyByLesserInteger(filtered, this.filter.quantityInvestmentsFrom, 'quantityInvestment')

      filtered = this.filterPropertyByGreaterFloat(filtered, this.filter.totalValueTo, 'totalInvestment')
      filtered = this.filterPropertyByLesserFloat(filtered, this.filter.totalValueFrom, 'totalInvestment')

      return filtered
    },
    salaryEvolutionData: function() {
      let flatData = _.chain(this.filteredData)
        .filter(f => f.financialInformations != null && f.financialInformations.length > 0)
        .flatMap(f => f.financialInformations)
        .map(m => ({
          employeeCountFullTime: m.employeeCountFullTime != null ? m.employeeCountFullTime : 0,
          employeeCountFullPart: m.employeeCountFullPart != null ? m.employeeCountFullPart : 0,
          employeeCountOthers: m.employeeCountOthers != null ? m.employeeCountOthers : 0,
          creation: m.creation,
        }))
        .value()

      if (flatData.length > 0) {
        let groupFormat = this.getDateTimeGroupFormat(flatData, 'creation')

        let data = _.chain(flatData)
          .orderBy(o => o.creation)
          .groupBy(o => moment(o.creation).format(groupFormat))
          .map((items, key) => ({
            key: key,
            employeeCountFullTime: _.sumBy(items, s => s.employeeCountFullTime),
            employeeCountFullPart: _.sumBy(items, s => s.employeeCountFullPart),
            employeeCountOthers: _.sumBy(items, s => s.employeeCountOthers),
          }))
          .value()

        return this.generateBarStackedChartFromData(
          data,
          'dashboard.project',
          false,
          'employeeCountFullTime',
          'employeeCountFullPart',
          'employeeCountOthers'
        )
      } else {
        return this.emptyGraph
      }
    },
    projectTypeData: function() {
      return this.getChartData('projectTypeText')
    },
    regionData: function() {
      return this.getChartData('regionText')
    },
    sectorOfActivityData: function() {
      return this.getChartData('sectorOfActivityText')
    },
    statusData: function() {
      return this.getChartData('companyStatusText')
    },
    total: function() {
      return this.filteredData.length
    },
    totalWithInvestment: function() {
      return _.filter(this.filteredData, f => f.investments != null && f.investments.length > 0).length
    },
    totalInvestments: function() {
      return _.chain(this.filteredData)
        .flatMap(f => f.investments)
        .map('id')
        .value().length
    },
    totalInvested: function() {
      return _.chain(this.filteredData)
        .flatMap(f => f.investments)
        .map('totalValue')
        .sum()
        .value()
        .toFixed(0)
    },
    meanPreMoney: function() {
      return _.chain(this.filteredData)
        .filter(f => f.preInvestiment != null)
        .meanBy(m => m.preInvestiment)
        .value()
        .toFixed(0)
    },
    totalEmployeFullTime: function() {
      return _.sumBy(this.employesMap, 'employeeCountFullTime')
    },
    totalEmployePartTime: function() {
      return _.sumBy(this.employesMap, 'employeeCountFullPart')
    },
    totalEmployeOther: function() {
      return _.sumBy(this.employesMap, 'employeeCountOthers')
    },
    totalEmploye: function() {
      return this.totalEmployeFullTime + this.totalEmployePartTime + this.totalEmployeOther
    },
    employesMap: function() {
      return _.chain(this.filteredData)
        .filter(f => f.financialInformations != null && f.financialInformations.length > 0)
        .flatMap(f => f.financialInformations)
        .map(m => ({
          employeeCountFullTime: m.employeeCountFullTime != null ? m.employeeCountFullTime : 0,
          employeeCountFullPart: m.employeeCountFullPart != null ? m.employeeCountFullPart : 0,
          employeeCountOthers: m.employeeCountOthers != null ? m.employeeCountOthers : 0,
          status: m.status,
        }))
        .filter(f => f.status)
        .value()
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let projectService = ServiceFactory.create(ProjectServiceClient)
        let companyService = ServiceFactory.create(CompanyServiceClient)
        let competencyService = ServiceFactory.create(CompetencyServiceClient)
        let investmentService = ServiceFactory.create(InvestmentServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)

        self.getDashBoardData(projectService)
        self.getFilterData(addressService, projectService, companyService, competencyService, investmentService)
      })
    },
    getFilterData: function(addressService, projectService, companyService, competencyService, investmentService) {
      let self = this

      investmentService.getTypes().then(res => {
        self.investmentTypes = res
      })
      investmentService.getCategorys().then(res => {
        self.investmentCategorys = res
      })
      addressService.getRegions().then(res => {
        self.regions = res
      })
      companyService.getCompanyStage().then(res => {
        self.companyStages = res
      })
      companyService.getSectorOfActivity().then(res => {
        self.sectors = res
      })
      companyService.getOrigin().then(res => {
        self.origins = res
      })
      projectService.getCompanyStatus().then(res => {
        self.companyStatuses = res
      })
      projectService.getReasonInactif().then(res => {
        self.reasonsInactif = res
      })
      competencyService.getCellules().then(res => {
        self.cellulles = res.items
      })
      projectService.getProjectType().then(res => {
        self.projectTypes = res
      })
      projectService.getProcessStatus().then(res => {
        self.processStatuses = res
      })
    },
    getDashBoardData: function(service) {
      let self = this
      service
        .getDashboardData()
        .then(res => {
          self.data = res
          self.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Project.vue